import { _Base } from "./_Base";
import { endpoints } from "./endpoints";

export class KeenAPI extends _Base {
  additionalCookies = null;
  constructor(_additionalCookies) {
    super();
    this.additionalCookies = _additionalCookies;
  }

  endPointRoot = process.env.REACT_APP_ROOT_T_API + endpoints.keen.root;
  async proxy(keenRequestObj) {
    const url = this.endPointRoot;
    try {
      const response = await this.preparePost(
        url,
        { params: keenRequestObj, additionalCookies: this.additionalCookies },
        null
      );
      return response;
    } catch (error) {
      alert(
        `something went wrong on fetchin user last access! you can keep using the app but last access from user won't be available. please, contact the developers team! `
      );
      console.error(
          `something went wrong on fetchin user last access!`
      );
      throw Error;
    }
  }
}
